// Translation: Terms of service > Landing > Form (German)
export default Object.freeze({})
